import styled from 'styled-components'

export const Wrapper = styled.div<{ isInvalid: boolean }>`
  display: flex;
  width: 100%;
  height: 200px;
  min-width: 250px;
  border: ${(props) =>
    `2px dashed ${props.isInvalid ? 'var(--color-danger)' : 'var(--color-primary)'}`};
  background-color: var(--surface-bg);
  margin-top: 1rem;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
  margin: auto;
`
